// Experience page - detailed view of all experiences

import { ExperienceSection } from '../components/sections/ExperienceSection';
import { useCandidateData } from '../hooks/useCandidateData';

export function Experience() {
  const { experiences, isLoading } = useCandidateData();

  return (
    <main className="pt-16">
      <ExperienceSection experiences={experiences} isLoading={isLoading} />
    </main>
  );
}
